import { ErrData } from '@iotv/iotv-v3-types'
import fs from 'fs'
import path from 'path'

export const getFileLike = async (like: string) => {
  let res: string | undefined = undefined

  const fileName = path.basename(like)
  const extName = path.extname(like)
  const pathName = path.dirname(like)
  console.log('', { pathname: pathName, fileName, extName })

  // const dirStatRes = await new Promise( (resolve) => fs.stat( pathName, ( err, stats ) => resolve({ err, stats })));
  // console.log('stats', dirStatRes)

  const dirContentsRes: ErrData<string[]> = await new Promise((resolve) => fs.readdir(pathName, (err, files) => resolve({ err, data: files })))
  //console.log('files', dirContentsRes)

  if (dirContentsRes.data) {
    const matchedFileName = dirContentsRes.data.find((item) => {
      const baseName = path.basename(item)
      const extName = path.extname(item)
      const fileNameToMatch = baseName.replace(extName, '')
      return fileNameToMatch === fileName
    })

    res = matchedFileName ? path.join(pathName, matchedFileName) : undefined
  } else {
    console.log(dirContentsRes.data && (dirContentsRes.data as any) instanceof Array)
  }

  //console.log('File Name', res )

  return res
}
